import { getSelfOrNearestAncestorByClassName } from "../utils/dom";
import each from "lodash/each";
import { enforceTermsOnForm } from "../utils/Form";
import CustomEvent from "custom-event";

const Forms = () => {
  const checkOther: any = document.querySelector("input#other");
  const textareaOther: any = document.querySelector("textarea#otherText");

  if (checkOther && textareaOther) {
    checkOther.addEventListener("change", () => {
      const parent: Element = getSelfOrNearestAncestorByClassName(
        textareaOther,
        "formField"
      );
      if (!parent) return;
      if (checkOther.checked) {
        parent.classList.remove("hidden");
      } else {
        parent.classList.add("hidden");
        textareaOther.value = "";
      }
    });
  }

  const formSplitBtn = document.querySelector(".formSplit__button");
  if (formSplitBtn) {
    formSplitBtn.addEventListener("click", () => {
      const formSplitSection = document.querySelectorAll(".formSplit");
      if (formSplitSection.length) {
        formSplitSection[formSplitSection.length - 1].classList.toggle(
          "formSplit--active"
        );
        formSplitBtn.classList.toggle("formSplit__button--active");

        const evt: CustomEvent = new CustomEvent("FormSplit", {
          detail: {
            button: formSplitBtn,
            state:
              formSplitSection[formSplitSection.length - 1].classList.contains(
                "formSplit--active"
              ),
          },
        });
        window.dispatchEvent(evt);
        if (
          formSplitSection[formSplitSection.length - 1].classList.contains(
            "formSplit--active"
          )
        ) {
          window.sessionStorage.setItem("dealerContact", "true");
        }
      }
    });
  }

  each(document.querySelectorAll("form.contour"), enforceTermsOnForm);
};

export default Forms;

// import React from "react";
// import ReactDOM from "react-dom";
// import * as Request from "superagent";
// import each from "lodash/each";
// import { SuburbModel } from "../models/SuburbModel";
// import { ApiBasePath } from "../utils/ApiBasePath";

// interface InlineLocationSelectProps {
//   src: any;
//   dest: any;
// }

// interface InlineLocationSelectState {
//   showResults: boolean;
//   suburb: SuburbModel;
//   suburbs: SuburbModel[];
// }

// class InlineLocationSelect extends React.Component<InlineLocationSelectProps, InlineLocationSelectState> {
//   delayTimeout = null;
//   resetOnHide: boolean = false;

//   constructor(props) {
//     super(props);

//     this.state = {
//       showResults: false,
//       suburb: null,
//       suburbs: []
//     };
//   }

//   componentDidMount() {
//     const { src } = this.props;

//     src.addEventListener("input", e => {
//       if (this.delayTimeout !== "undefined") {
//         clearTimeout(this.delayTimeout);
//       }
//       this.delayTimeout = setTimeout(() => {
//         this.process(e.target.value);
//       }, 300);
//     });

//     src.addEventListener("keyup", e => {
//       if (e.keyCode === 13) {
//         e.preventDefault();
//         if (this.state.suburbs.length && this.state.showResults) {
//           this.select(this.state.suburbs[0]);
//         }
//       }
//     });

//     src.addEventListener("blur", e => {
//       this.reset();
//     });
//   }

//   reset() {
//     const { src, dest } = this.props;

//     if (!this.state.suburb) {
//       src.value = "";
//       dest.postcode.value = "";
//       dest.suburb.value = "";
//       dest.state.value = "";
//     } else {
//       this.select(this.state.suburb);
//     }
//   }

//   search(postcode, success, fail) {
//     const url = `${ApiBasePath.location}/${postcode}`;
//     Request.get(url).then(success, fail);
//   }

//   select(suburb: SuburbModel) {
//     const { src, dest } = this.props;

//     this.setState({ suburb, showResults: false });
//     src.value = `${suburb.name}, ${suburb.postcode}`;
//     dest.postcode.value = suburb.postcode;
//     dest.suburb.value = suburb.name;
//     dest.state.value = suburb.state;
//   }

//   process(input) {
//     const inputAsInt = parseInt(input);

//     if (input.length < 3) {
//       //Invalid postcode
//       return false;
//     }

//     if (isNaN(inputAsInt) || inputAsInt < 100 || inputAsInt > 9999) {
//       //Invalid postcode
//       return false;
//     }

//     this.search(
//       input,
//       response => {
//         const suburbs = response.body;
//         this.setState({
//           showResults: true,
//           suburbs
//         });
//       },
//       error => {
//         this.setState({
//           showResults: false,
//           suburbs: []
//         });

//         this.reset();
//       }
//     );
//   }

//   render() {
//     const { showResults, suburbs } = this.state;
//     return (
//       <div className={`dd dd--pcLookup ${showResults ? "dd--active" : ""}`}>
//         <ol className="dd__items">
//           {suburbs.map((suburb: SuburbModel, i: number) => {
//             return (
//               <div className="dd__item" key={`suburb${i}`} onClick={() => this.select(suburb)}>
//                 {suburb.name}
//               </div>
//             );
//           })}
//         </ol>
//       </div>
//     );
//   }
// }

// const Forms = () => {
//   const postcode = document.querySelector(".contourField.pclookup input");
//   const locationPostcode = document.querySelector(".contourField.pclookuppostcode input");
//   const locationSuburb = document.querySelector(".contourField.pclookupsuburb input");
//   const locationState = document.querySelector(".contourField.pclookupstate input");

//   if (!postcode || !locationPostcode || !locationSuburb || !locationState) return;

//   const locationSelect = document.createElement("div");
//   if (locationSelect) {
//     const destFields = { postcode: locationPostcode, suburb: locationSuburb, state: locationState };
//     ReactDOM.render(<InlineLocationSelect src={postcode} dest={destFields} />, locationSelect);
//     postcode.parentNode.appendChild(locationSelect);
//   }
// };

// export default Forms;
